import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

export type NewExperimentsType = {
	name: string;
	countries: Array<string>;
	languages: Array<string>;
	sample: Array<number>;
	variant: string | null;
};
// STATE
export const INITIAL_EXPERIMENT_STATE = {
	// NEW Experiments From BE
	newExperiments: [] as NewExperimentsType[],
};

const state = () => ({ ...INITIAL_EXPERIMENT_STATE });

type State = ReturnType<typeof state>;

// GETTERS
const getters: GetterTree<State, any> = {};

// ACTIONS
const actions: ActionTree<State, any> = {
	setNewExperiments({ commit }, newExperiments: NewExperimentsType[]) {
		commit('SET_NEW_EXPERIMENTS', newExperiments);
	},
};

// MUTATIONS
const mutations: MutationTree<State> = {
	SET_NEW_EXPERIMENTS: (state, newExperiments: NewExperimentsType[]) => {
		state.newExperiments = newExperiments;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
} as Module<State, any>;
